var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.499 19v-7.298h2.496l.375-2.845h-2.871V7.041c0-.823.232-1.384 1.437-1.384l1.535-.001V3.111A21.214 21.214 0 0013.234 3c-2.214 0-3.73 1.326-3.73 3.76v2.097H7v2.845h2.504V19h2.995z","fill":"currentColor"}));
}

FacebookInline.defaultProps = {"width":"22","height":"22","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
